import { FaWind } from "react-icons/fa";
import { FaRegBuilding, FaUsersGear } from "react-icons/fa6";
import { IoDocumentTextOutline, IoStatsChartOutline, IoWarningOutline } from "react-icons/io5";
import { LuClipboardList, LuPowerOff } from "react-icons/lu";
import { PiBinoculars, PiBriefcase, PiFolder, PiSkullLight } from "react-icons/pi";
import { RiShieldKeyholeLine } from "react-icons/ri";
import { HeaderMenuItem } from "../type/menu-type";


export const menuRoutes = {
    auth: {
        login: "/login",
        forgot_password: "/forgot-password",
        reset_password: "/reset-password",
    },
    dashboard: {
        path: "/dashboard",
    },
    organisations: {
        path: "/companies",
        create: "create",
        edit: ":id/edit",
    },
    roles: {
        path: "/roles",
        create: "create",
        edit: ":id/edit",
    },
    users: {
        path: "/users",
        create: "create",
        edit: ":id/edit/info",
        edit_permissions: ":id/edit/permissions",
        profile: {
            path: ":id/profile/",
            info: "info",
            documents: "documents",
            permissions: "permissions",
        },
    },
    clients: {
        path: "/clients",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
        },
    },

    parks: {
        path: "/parks",
        create: "create",
        edit: ":id/edit",
        profile: {
            path: ":id/profile/",
            info: "info",
            windTurbines: "wind-turbines",
            documents: "documents",
            issues: "issues",
            carrion: "carrion",
            stops: "stops",
            census: "census",
            ofc: "ofc",
        },
    },

    species: {
        path: "/species",
        profile: {
            path: ":id/profile/",
            info: "info",
        },
    },

    carrion: {
        path: "/carrion",
        profile: {
            path: ":id/profile/",
            info: "info",
            photos: "photos",
        },
    },

    issues: {
        path: "/issues",
        profile: {
            path: ":id/profile/",
            info: "info",
            photos: "photos",
        },
    },

    stops: {
        path: "/stops",
        profile: {
            path: ":id/profile/",
            info: "info",
            photos: "photos",
        },
    },

    census: {
        path: "/census",
        create: "create",
        createFromPark: "create/:parkId",
        edit: ":id/edit",
        editFromPark: ":id/edit/:parkId",
        profile: {
            path: ":id/profile/",
            info: "info",
            photos: "photos",
        },
    },

    ofc: {
        path: "/ofc",
        create: "create",
        createFromPark: "create/:parkId",
        edit: ":id/edit",
        editFromPark: ":id/edit/:parkId",
        profile: {
            path: ":id/profile/",
            info: "info",
            photos: "photos",
        },
    },

    documents: {
        path: "/documents",
    },

    reports: {
        path: "/reports",
    }
};

export const menuItems: HeaderMenuItem = {
    dashboardMenu: {
        id: "dashboard",
        sectionName: "Inicio",
        name: "Panel de control",
        path: "/dashboard",
        type: "enhance",
        permissions_required: [{
            group: "dashboard",
            action: "get",
        }],
    },
    administrationMenu: {
        id: "administration",
        name: "Administración",
        path: "/admin",
        react_icon: PiFolder,
        type: "enhance",
        items: [
            {
                id: "access-and-credentials",
                name: "Control de acceso",
                path: "",
                react_icon: FaUsersGear,
                subMenuItems: [
                    {
                        name: "Usuarios",
                        href: menuRoutes.users.path,
                        icon: "FolderIcon",
                        permissions_required: [
                            {
                                group: "user",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Roles",
                        href: menuRoutes.roles.path,
                        icon: "RolesIcon",
                        permissions_required: [
                            {
                                group: "roles",
                                action: "list",
                            },
                        ],
                    },
                ],
            },
            {
                id: "clients",
                name: "Clientes",
                path: menuRoutes.clients.path,
                react_icon: PiBriefcase,
                permissions_required: [{
                    group: 'clients',
                    action: "list",
                }],
            },
            {
                id: "parks",
                name: "Parques Eólicos",
                path: menuRoutes.parks.path,
                react_icon: FaWind,
                permissions_required: [{
                    group: 'park',
                    action: "list",
                }],
            },
            {
                id: "species",
                name: "Especies",
                path: menuRoutes.species.path,
                react_icon: LuClipboardList,
                permissions_required: [{
                    group: "species",
                    action: "list",
                }],
            },
            {
                id: "issues",
                name: "Incidencias",
                path: menuRoutes.issues.path,
                react_icon: IoWarningOutline,
                permissions_required: [{
                    group: "issues",
                    action: "list",
                }],
            },
            {
                id: "carrion",
                name: "Carroñas",
                path: menuRoutes.carrion.path,
                react_icon: PiSkullLight,
                permissions_required: [{
                    group: "carrion",
                    action: "list",
                }],
            },
            {
                id: "census",
                name: "Censos",
                path: menuRoutes.census.path,
                react_icon: LuClipboardList,
                permissions_required: [{
                    group: "census",
                    action: "list",
                }],
            },
            {
                id: "ofc",
                name: "OFC",
                path: menuRoutes.ofc.path,
                react_icon: PiBinoculars,
                permissions_required: [{
                    group: "census",
                    action: "list",
                }],
            },
            {
                id: "stops",
                name: "Paradas",
                path: menuRoutes.stops.path,
                react_icon: LuPowerOff,
                permissions_required: [{
                    group: "preventive_stops",
                    action: "list",
                }],
            },
            {
                id: "documents",
                name: "Documentos",
                path: menuRoutes.documents.path,
                react_icon: IoDocumentTextOutline,
                permissions_required: [{
                    group: "document",
                    action: "list",
                }],
            },
            {
                id: "reports",
                name: "Informes",
                path: menuRoutes.reports.path,
                react_icon: IoStatsChartOutline,
                permissions_required: [{
                    group: "document",
                    action: "list_reports",
                }],
            }
        ]

    },
    superAdminMenu: {
        id: "title-super-admin",
        name: "Panel Administración",
        icon: "GreenLeafIcon",
        react_icon: PiFolder,
        type: "enhance",
        columns: "1",
        permissions_required: [
            {
                group: "companies",
                action: "admin_company",
                isSuperAdmin: true,
            },
        ],
        items: [
            {
                id: "organisations",
                name: "Organizaciones",
                path: menuRoutes.organisations.path,
                react_icon: FaRegBuilding,
                permissions_required: [
                    {
                        group: "companies",
                        action: "admin_company",
                        isSuperAdmin: true,
                    },
                ],
                subMenuItems: [
                    {
                        name: "Organizaciones",
                        href: menuRoutes.organisations.path,
                        permissions_required: [
                            {
                                group: "companies",
                                action: "list",
                            }
                        ],
                    },
                ]
            },
            {
                id: "roles",
                name: "Roles",
                path: menuRoutes.roles.path,
                react_icon: RiShieldKeyholeLine,
                permissions_required: [
                    {
                        group: "roles",
                        action: "admin_roles",
                        isSuperAdmin: true,
                    },
                ],
                subMenuItems: [
                    {
                        name: "Lista Roles",
                        href: menuRoutes.roles.path,
                        permissions_required: [
                            {
                                group: "roles",
                                action: "list",
                            }
                        ],
                    },
                    {
                        name: "Crear Rol",
                        href: menuRoutes.roles.path + '/' + menuRoutes.roles.create,
                        permissions_required: [
                            {
                                group: "roles",
                                action: "create",
                            }
                        ],
                    },
                ]
            },
        ],
    },

};